export default {
  methods: {
    handleError(err) {
      if (!err.error) return;
      if (
        err.error.key === 'apis.talent.evaluation.is.deleted' ||
        err.error.key === 'apis.talent.evaluation.deleted'
      ) {
        this.$confirm('', this.$t('pc_gwnl_error_eval_deleted'), {
          type: 'error',
          closeOnClickModal: false,
          showCancelButton: false
        }).then(() => {
          this.$router.push({
            name: 'eval.center'
          });
        });
      } else if (
        err.error.key === 'apis.talent.evaluation.available.num.not.enough'
      ) {
        this.$confirm(
          this.$t('pc_gwnl_error_eval_leftConfirm', {
            count: err.error.data[0]
          }),
          this.$t('pc_gwnl_error_eval_LeftNotEnough'),
          {
            type: 'error',
            showCancelButton: false,
            confirmButtonText: this.$t('pc_gwnl_global_msg_known')
          }
        );
      } else {
        this.$talentHandleError(err);
      }
    }
  }
};
